var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#B28B67;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#191847;}\r\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#1F28CF;}\r\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#2B44FF;}\r\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#E4E4E4;}\r\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:#C5CFD6;}\r\n\t.st6{fill-rule:evenodd;clip-rule:evenodd;fill:#2F3676;}\r\n\t.st7{fill-rule:evenodd;clip-rule:evenodd;fill:#E87613;}\r\n\t.st8{fill-rule:evenodd;clip-rule:evenodd;fill:#DDE3E9;}\r\n\t.st9{fill-rule:evenodd;clip-rule:evenodd;fill:#FF9B21;}\r\n\t.st10{fill-rule:evenodd;clip-rule:evenodd;fill-opacity:0.1;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("desc", null, "Created with Sketch."), /*#__PURE__*/React.createElement("g", {
    id: "humaaans_x2F_sitting-3_00000147933900833338929150000005916075360615014306_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "A-Human_x2F_Sitting_00000155110107583505082100000012188203039586615196_",
    transform: "translate(190.000000, 200.500000) scale(-1, 1) translate(-190.000000, -200.500000) translate(40.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Head_x2F_Front_x2F_Short-Beard_00000013188094770511228710000018417447309392711342_",
    transform: "translate(82.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Head_00000023993443331189875320000012858379813269074610_",
    transform: "translate(54.000000, 31.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-72.5,67.2c-4.8-5.6-8-12.4-7.4-20.1C-78.4,25-47.6,29.8-41.6,41s5.3,39.5-2.5,41.5 c-3.1,0.8-9.7-1.2-16.4-5.2l4.2,29.7H-81L-72.5,67.2z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Hair_00000062175378682045075970000015909885261076209597_",
    className: "st1",
    d: "M-5.2,80.6c0.9,13.2,3.5,19.8,7.5,19.8 c6.1,0,11.3-3.9,14-3.9c2,0,1.5,2.4,0.2,4.3c-1.1,1.5-6.3,2.9-6.3,5.3c0,2.3,4.1,0.5,4.1,1.9c0,2.3,0.7,6.6-3.2,6.6 c-4,0-15.5-1.5-17.4-7.4c-1.3-3.8-2.1-11.8-2.5-23.8c-0.2,0-0.5,0-0.7,0c-3.4,0-6.2,2.8-6.2,6.2c0,1.7,0.7,3.3,1.9,4.4 c-1.4,2-3,4.1-4.9,6.3c-6.9-4.2-12.1-16.3-5.3-28c1.9-5.7,6.1-8.8,11.1-10.2c4.1-1.7,8.3-1.9,11.8-0.9c7,0.6,13.2,2.7,14.9,4 c0,6.6-1.3,8.5-12.2,8.4C-1,75-3,77.4-5.2,80.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Bottom_x2F_Sitting_x2F_Wheelchair_00000048466863301462550770000013306700529672955020_",
    transform: "translate(0.000000, 187.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Skin_00000018919803274230291600000006356072654410521474_",
    className: "st0",
    d: "M177.9,55.6c7.4-10.1,26-3.4,26,4.9 c0,21.9-20,125.8-21,132.3c-1,6.6-12.2,8.7-12.9,0.5c-1-13-3-58.2-1-79.3c0.6-6.1,1.2-12.1,1.8-17.6 c-10.5,18.9-26.5,45.5-47.9,79.9l-11.9-5.4c9.3-30.8,17-52.5,23-65.2c10.2-21.7,19.9-40.3,23.9-46.9 C163.1,50.2,171.8,51.4,177.9,55.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Leg-Back_00000103232147508619488330000005306513989596754311_",
    className: "st2",
    d: "M111.7,153.9l40.9-96.8 c9.8-15.7,37.2,3.2,33.9,12.3c-7.6,20.7-46.1,87.9-48.4,94L111.7,153.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Leg-Front_00000063617365441261684250000003845162436104205732_",
    className: "st3",
    d: "M204.9,67.8c0,27.4-12,91.9-12,98 l-29.1-1c5.1-56.1,7.2-84.3,6.4-84.7c-1.8-0.9-73.6,9.9-95.1,10.7C44,92,31.2,73,30.2,36.8h60.1c51.4,6.1,85.2,10.4,101.4,12.8 C202,51.2,204.9,60.2,204.9,67.8z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Accessories_x2F_Shoe_x2F_Flat-Sneaker_00000159438543541320188360000001971218273933888676_",
    transform: "translate(243.000000, 111.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "shoe_00000005958719870652805410000015664446745288876175_",
    className: "st4",
    d: "M-133.7,60.9c-1.2,3.1-1.7,5.4-1.7,6.9 c0,1.9,0.3,4.6,0.9,8.2c2.2,0,21.6,0,58.3,0c1.5-5,0.6-7.7-2.6-8.1c-3.3-0.4-6-0.8-8.1-1.1L-114,54.7c-0.5-0.2-1.1,0-1.4,0.5 c0,0,0,0,0,0l-1.7,4.2c-3,1.4-5.5,2.1-7.4,2.1c-1.5,0-3.7-0.6-6.4-1.9l0,0c-1-0.5-2.3,0-2.7,1 C-133.6,60.8-133.6,60.9-133.7,60.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Objects_x2F_Seat_x2F_Cube-2_00000166673853233412203340000003980912403551302804_",
    transform: "translate(216.820222, 128.225467) rotate(14.000000) translate(-216.820222, -128.225467) translate(186.320222, 108.225467)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Seat_00000157290343967342896470000004699145369690262413_",
    className: "st5",
    d: "M-38.8,58.3l6.9,0 c9.1,0,16.5,7.4,16.5,16.5v8.3c0,9.1-7.4,16.5-16.5,16.5h-6.9c-9.1,0-16.5-7.4-16.5-16.5v-8.3C-55.3,65.7-47.9,58.3-38.8,58.3z  M-43.6,67.6c-2.3,0-4.1,1.9-4.1,4.1v14.4c0,2.3,1.9,4.1,4.1,4.1h16.5c2.3,0,4.1-1.9,4.1-4.1V71.8c0-2.3-1.9-4.1-4.1-4.1H-43.6 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Accessories_x2F_Shoe_x2F_Flat-Sneaker_00000073701027727172497350000010420677420002480513_",
    transform: "translate(243.000000, 111.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "shoe_00000080924758471147803280000010143273534110231692_",
    className: "st4",
    d: "M-74.6,66.8c-1.2,3.1-1.7,5.4-1.7,6.9 c0,1.9,0.3,4.6,0.9,8.2c2.2,0,21.6,0,58.3,0c1.5-5,0.6-7.7-2.6-8.1c-3.3-0.4-6-0.8-8.1-1.1L-55,60.7c-0.5-0.2-1.1,0-1.4,0.5 c0,0,0,0,0,0l-1.7,4.2c-3,1.4-5.5,2.1-7.4,2.1c-1.5,0-3.7-0.6-6.4-1.9v0c-1-0.5-2.3,0-2.7,1C-74.6,66.7-74.6,66.8-74.6,66.8z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Base_00000065049253546760212230000011472865708790769839_",
    className: "st6",
    d: "M171.3,192.9h47.6c2,0,3.6,1.6,3.6,3.6l0,0 c0,2-1.6,3.6-3.6,3.6h-47.6c-2,0-3.6-1.6-3.6-3.6l0,0C167.7,194.6,169.3,192.9,171.3,192.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Seat_00000018953441932274989510000013213999803340214928_",
    className: "st6",
    d: "M27,43h110.6c5.7,0,10.3,4.6,10.3,10.3V104 H20.8c-2.3,0-4.1-1.9-4.1-4.1V53.4C16.6,47.7,21.3,43,27,43z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Wheel-Stuff_00000070841255572059363810000006475439659012830366_",
    className: "st6",
    d: "M137.6,43h2.4 c5.1,0,9.4,3.7,10.2,8.7l22.7,138.1h-11.5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Front-Wheel_00000114071235344455566180000004544663836599929239_",
    className: "st1",
    cx: 167.7,
    cy: 192,
    r: 18.6
  }), /*#__PURE__*/React.createElement("g", {
    id: "Wheel_00000014624738767878709570000005478890870383596186_",
    transform: "translate(36.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-5.8,194.5c-43.4,0-78.6-35.2-78.6-78.6s35.2-78.6,78.6-78.6S72.7,72.6,72.7,116S37.6,194.5-5.8,194.5z  M-5.8,180.1c35.4,0,64.1-28.7,64.1-64.1S29.6,51.9-5.8,51.9S-69.9,80.6-69.9,116S-41.2,180.1-5.8,180.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Wheel-Stuff_00000126325781452793293320000000068229706256713393_",
    x: -10.1,
    y: 184.1,
    transform: "matrix(0.8829 0.4695 -0.4695 0.8829 53.7031 16.3467)",
    className: "st1",
    width: 8.3,
    height: -136.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Wheel-Stuff_00000145766238376259200300000009004221624046902670_",
    className: "st1",
    d: "M41,66.3l2.9,2.9 c0.8,0.8,0.8,2.1,0,2.9l-93.6,93.6c-0.8,0.8-2.1,0.8-2.9,0l-2.9-2.9c-0.8-0.8-0.8-2.1,0-2.9L38,66.3 C38.8,65.5,40.1,65.5,41,66.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Wheel-Stuff_00000135672839841630467210000010675127318517470865_",
    className: "st1",
    d: "M62.3,113.8v4.1 c0,1.1-0.9,2.1-2.1,2.1H-72.1c-1.1,0-2.1-0.9-2.1-2.1v-4.1c0-1.1,0.9-2.1,2.1-2.1H60.2C61.4,111.7,62.3,112.7,62.3,113.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Wheel-Stuff_00000078046808611606213000000001310835465900988351_",
    className: "st1",
    d: "M43.9,162.8l-2.9,2.9 c-0.8,0.8-2.1,0.8-2.9,0l-93.6-93.6c-0.8-0.8-0.8-2.1,0-2.9l2.9-2.9c0.8-0.8,2.1-0.8,2.9,0l93.6,93.6 C44.7,160.6,44.7,162,43.9,162.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Body_x2F_Hoodie_00000165934546649909000970000011409742380042434707_",
    transform: "translate(22.000000, 82.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Skin_00000134240735466807150120000005026109860188213126_",
    className: "st0",
    d: "M112.4,128.7l33,24.2 c8.9,2.4,16.4,5.4,22.4,9c1.4,1.3,3.1,3.9-2.7,3.5c-5.9-0.5-12.1-0.7-12.9,1.3c-0.8,2,2.7,4.4,1.1,7.1 c-1.1,1.8-6.3-2.7-15.5-13.6l-32.7-13.5L112.4,128.7z M-14.3,129.4l21.6,0.1c-13.3,43.1-20.5,65.9-21.6,68.5 c-2.4,5.9,2.7,15,4.8,19.8c-7.1,3.2-6.3-8.5-15.2-4.4c-8.1,3.8-14.3,10.6-23.7,4.8c-1.2-0.7-2.4-3.4,0.6-5.5 c7.6-5.2,18.6-14.3,20-17.3C-25.6,191.4-21.1,169.4-14.3,129.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Coat-Back_00000168799140726170581470000010340870383800493230_",
    className: "st7",
    d: "M47.1,38.9l8.9-1.5 c33.2,28.7,46.8,83.7,87.4,112.9l-9.8,12.1C63.2,153.6,45.7,86.5,47.1,38.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shirt_00000026883649319933302150000014907220127726828164_",
    className: "st8",
    d: "M8.2,151.1c35.8,0,62.2,0,79.1,0 c3.6,0,2.9-5.2,2.4-7.9c-6-30.4-29.6-63.2-29.6-106.4l-22.8-3.6C18.4,63.6,11.9,101,8.2,151.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Coat-Front_00000078040298981576417820000003389780800935305124_",
    className: "st9",
    d: "M8.8,63.1c-3.3-1-5.9-3.2-7.9-6.7 c-8.3-15-5.3-23.3,3.6-26.1s16.9,2.9,31.1,2.9c0.8,0,1.5,0,2.1,0.1l7.1,0.4c20.5,69.5,26.1,115.8,17,139H-0.5 c-3.7,8.6-7.2,15.8-10.6,21.7h-17C-29.6,142.9-17.3,99.1,8.8,63.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shade_00000119831882337208623290000002119233918139640233_",
    className: "st10",
    d: "M13.1,137.2c2,16.4,5.1,28.3,9.5,35.7 H-0.5C3.8,162.8,8.4,150.9,13.1,137.2z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocial);
export default __webpack_public_path__ + "static/media/social.27d6ed995e66f92fa9c7dfc036ba932f.svg";
export { ForwardRef as ReactComponent };